export interface IDimension {
    num: number;
    unit: string;
}

/* Utility class for parsing string values */
class DimensionUtils {
    static parseDimension(value: string): IDimension {
        const match = value.trim().match(/^(\d+(\.\d+)?)(.*)$/);
        if (!match) return { num: NaN, unit: "" };

        const [, numStr,, unit] = match;
        const num = parseFloat(numStr);
        return { num, unit };
    }

    static parseDimensions(value: string): IDimension[] {
        const values = value.split(',');
        return values.map(v => this.parseDimension(v));
    }

    static formatDimension(num: number, unit: string): string {
        return `${num}${unit}`;
    }

    static formatDimensions(dimensions: IDimension[]): string {
        return dimensions.map(d => this.formatDimension(d.num, d.unit)).join(',');
    }

}

export default DimensionUtils;
